import { isFunction } from "~/tools/is-function";

import { purry } from "../_purry";
import { unpurry } from "../_unpurry";

export interface PluralizeVariants<TResult = string> {
	0?: TResult;
	1: TResult;
	more: TResult | ((count: number) => TResult);
}

function pluralizeImplementation(count: number, variants: PluralizeVariants): string {
	if (count === 1) {
		return variants[1];
	}

	const formatter = count === 0 ? (variants[0] ?? variants.more) : variants.more;

	if (isFunction(formatter)) {
		return formatter(count);
	}

	return formatter;
}

// data-first
function pluralizePurry<TResult = string>(count: number, variants: PluralizeVariants<TResult>): TResult;

// data-last
function pluralizePurry<TResult = string>(variants: PluralizeVariants<TResult>): (count: number) => TResult;

// curried
function pluralizePurry(...args: ReadonlyArray<unknown>): unknown {
	return purry(pluralizeImplementation, args);
}

export const pluralize = unpurry(pluralizePurry, 2);
